import { ChangeEvent } from 'react';
import { TextField } from '@mui/material';
import { GridSearchIcon } from '@mui/x-data-grid';
import { useTranslation } from 'react-i18next';

import { styles } from './styles';

type SearchFilterProps = {
  filterValue: string;
  onChange: (event: ChangeEvent<HTMLInputElement>) => void;
  placeholder?: string;
};

export const SearchFilter = ({ filterValue, onChange, placeholder }: SearchFilterProps) => {
  const { t } = useTranslation();

  return (
    <TextField
      onChange={onChange}
      value={filterValue}
      placeholder={placeholder ?? t('GLOBAL.SEARCH_BY_NAME_PLACEHOLDER')}
      InputProps={{
        startAdornment: <GridSearchIcon />,
      }}
      sx={styles.filter}
    />
  );
};
